import Image from 'next/image'; // Updated import
import { useParams, usePathname, useSearchParams } from 'next/navigation';

import { Text, TextKeyValuePair } from '@/components/atomic/nuclei';
import {
  homePageBannerDescriptionIconValuePair,
  staticMediaStoreBaseURL
} from '@/config/common';
import {
  GENERIC_HEBA_PAGE_ROUTE,
  getPlanEventWithHebaURL
} from '@/services/planEventWithHeba.service';

const PlanWithHaflaCTA = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = useParams();
  const planEventWithHebaURL = getPlanEventWithHebaURL({
    pageRoute: GENERIC_HEBA_PAGE_ROUTE,
    params,
    pathname,
    searchParams
  });

  return (
    <div
      className='mt-8 flex flex-row cursor-pointer z-10 rounded-full h-14 w-80 bg-white items-center justify-between plan-with-ai-style hover:shadow-2xl'
      onClick={() => {
        window.open(planEventWithHebaURL, '_self');
      }}
    >
      <Text
        {...{
          className:
            'uppercase font-normal text-xl leading-6 plan-with-ai-text pl-7',
          content: 'plan with hafla ai'
        }}
      />
      <div className='plan-with-ai-arrow-style rounded-full w-10 h-10 flex items-center justify-center mr-2'>
        <Image
          className='transform rotate-180'
          alt='plan with hafla ai icon'
          height={11}
          src={`${staticMediaStoreBaseURL}/icons/back.svg`}
          width={16}
        />
      </div>
    </div>
  );
};

const DesktopHomeBanner = () => (
  <div className='flex flex-row justify-between relative hero-background-web'>
    <div className='flex flex-col gap-3 mt-32 ml-10 justify-between'>
      <div>
        <TextKeyValuePair
          {...{
            label: 'Experience AI Powered Event Planning',
            labelClass: 'text-56 text-white font-normal w-10 hero-heading z-20',
            spaceTop: '',
            value: 'By Expert Planners, with Professional Partners,',
            valueClassName: 'text-white text-base font-medium w-2/4 z-20'
          }}
        />
        <Text
          {...{
            className: 'text-white text-base font-medium z-20 w-2/4',
            content: 'for Everything for Entire Event'
          }}
        />
        <PlanWithHaflaCTA />
      </div>
      <div className='bottom-center-align pb-5'>
        <div className='grid grid-cols-3'>
          {homePageBannerDescriptionIconValuePair.map(
            ({ icon, title, subTitle }, index) => (
              <div
                key={title}
                className={`flex gap-2 z-20 ${
                  index === homePageBannerDescriptionIconValuePair.length - 1
                    ? '-mx-3'
                    : 'mx-5'
                }`}
              >
                <Image
                  alt='ideas icon'
                  height={40}
                  src={`${staticMediaStoreBaseURL}/icons/${icon}`}
                  width={40}
                />
                <TextKeyValuePair
                  {...{
                    className: 'flex flex-col gap-half',
                    label: title,
                    labelClass: 'text-white text-base font-semibold',
                    spaceTop: '',
                    value: subTitle,
                    valueClassName: 'text-white text-sm font-medium'
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>
      <div className='bottom-overlay-banner-description'></div>
    </div>
    <div className='banner-image-web'>
      <Image
        alt='Hafla desktop banner'
        height={558}
        width={936}
        src={`${staticMediaStoreBaseURL}/home-page-banner/home-page-banner.png`}
        style={{
          objectFit: 'cover',
          width: '936px',
          height: '558px'
        }}
        priority
      />
    </div>
  </div>
);

export default DesktopHomeBanner;
